import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ClientDto, Client} from "@/types/client";
import store from "@/store";
import ModuleApi from "@/store/api";
import {FullClientInfoDto, FullClientInfoRs, SetNotesRq} from "@/types/clientDetails";
import {mapToSetNotesRq, mapToFullClientInfoDto, mapToClientDto, mapToUpdateClientInfoRq} from "@/mappers/clients";

@Module({
    name: 'clients',
    dynamic: true,
    namespaced: true,
    store,
})
class ModuleClients extends VuexModule {
    private clients: ClientDto[];

    //Get client by clientId from server
    @Action
    async getClientByClientId(clientId: string) {
        console.log(`getClientByClientId ${clientId}`)
        const response = await ModuleApi.GET(`/api/cabinet/clients/${clientId}`) as FullClientInfoRs;
        return mapToFullClientInfoDto(response);
    }

    //Get all clients from server
    @Action({ commit: 'onAllClientsLoaded' })
    async getAllClients() {
        return await ModuleApi.GET('/api/cabinet/clients/') as Client[];
    }

    @Action
    async setNotes(fullClientDto: FullClientInfoDto) {
        const request = mapToSetNotesRq(fullClientDto);
        const clientId = fullClientDto.clientId;
        return await ModuleApi.PUT({url: `/api/cabinet/clients/${clientId}/set-notes`, body: request}) as FullClientInfoRs
    }

    @Action
    async updateClientInfo(fullClientDto: FullClientInfoDto) {
        const request = mapToUpdateClientInfoRq(fullClientDto);
        const clientId = fullClientDto.clientId;
        return await ModuleApi.PUT({url: `/api/cabinet/clients/${clientId}`, body: request})
    }

    public get allClients() {
        return this.clients;
    }

    @Mutation
    public onAllClientsLoaded(clientsFromServer: Client[]) {
        this.clients = clientsFromServer.map(client => mapToClientDto(client))
    }
 }

 export default getModule(ModuleClients);
